import React, { useState } from "react";
import { FaPlus } from "react-icons/fa";
import NewKeyModal from "../../components/Dashboard/NewKeyModal";

const OpenAISettings = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleAddKeyClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleCreateNewKey = ({ key, comment }) => {
    console.log("Creating new key:", { key, comment });
    // Typically send data to backend here
    setIsModalOpen(false);
    // Optionally add a toast for success
  };

  return (
    // Main container with consistent layout and background
    <div className="bg-slate-100 min-h-screen p-8 lg:p-12 font-sans">
      <div className="max-w-6xl mx-auto">
        {/* Header Section */}
        <header>
          <h1 className="text-4xl font-bold text-slate-800">OpenAI Settings</h1>
          <p className="mt-3 text-slate-600 max-w-4xl leading-relaxed">
            In this section, you can add your OpenAI keys. Without them, you will not be able to
            create Chatbots and Assistants. You can get a key on the{" "}
            <a
              href="https://platform.openai.com/api-keys"
              target="_blank"
              rel="noopener noreferrer"
              className="font-semibold text-blue-500 hover:text-cyan-400 transition-colors"
            >
              OpenAI website
            </a>
            . We check your keys to make sure they work — invalid keys cannot be added. Before
            adding a key, please ensure your OpenAI account balance is positive.
          </p>
        </header>

        {/* Main Content Card */}
        <div className="mt-16 bg-white rounded-xl shadow-sm p-8 relative">
          {/* "+ Add key" Button */}
          <button
            onClick={handleAddKeyClick}
            className="absolute top-0 left-8 -translate-y-1/2 flex items-center gap-2 bg-blue-500 text-white font-semibold px-5 py-2 rounded-lg shadow-md hover:bg-blue-600 transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            <FaPlus className="text-lg" />
            Add key
          </button>

          {/* Call-to-Action Section */}
          <div className="flex flex-col items-center justify-center text-center py-24">
            <h2 className="text-4xl font-medium text-slate-800 max-w-2xl leading-tight">
              <span className="font-bold text-blue-500">Get your first OpenAI key</span> to start
              creating chatbots
            </h2>
            <p className="mt-6 text-slate-700 text-lg">
              Need help? Write to the TG support chat{" "}
              <span className="text-cyan-400 font-semibold">support@mnrtechnologies.com</span>
            </p>
          </div>
        </div>
      </div>

      {/* New Key Modal */}
      <NewKeyModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onCreateKey={handleCreateNewKey}
      />
    </div>
  );
};

export default OpenAISettings;
